import api from '../api/api';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import constants from '../constants/constants';
import { i18n } from '../i18n/i18n';
import { useContext, useState } from 'react';
import { NOTIFICATION, useNotifications as useNotificationsMessages } from '@cellebrite/saas-ui-common';
import { AuthContext } from './authContext';
export default function useNotifications(wsId: number | null) {
    const {
        user: { id: userId },
    } = useContext(AuthContext);
    const [exportPdfSuccessMessageStack, setExportPdfSuccessMessageStack] = useState([]);
    const [showMessage] = useNotificationsMessages();
    const queryClient = useQueryClient();
    const { data: notifications } = useQuery<Array<any>>(
        ['notifications', wsId, userId],
        ({ queryKey }) => api.notifications.fetchNotifications(queryKey[1] as number, queryKey[2] as string),
        {
            enabled: !!wsId,
            refetchInterval: constants.NOTIFICATIONS_POLLING_DELAY,
            onSuccess: (notifications) => {
                notifications.forEach((notification) => {
                    const idIndex = exportPdfSuccessMessageStack.indexOf(notification.exportId);
                    if (notification.type === 'Export' && idIndex >= 0) {
                        showMessage(
                            i18n.translate(
                                notification.exportType === 'PDF'
                                    ? 'REPORT_PDF_GENERATION_SUCCESS'
                                    : 'REPORT_JSON_GENERATION_SUCCESS',
                            ),
                            NOTIFICATION.TYPE.SUCCESS,
                        );
                        exportPdfSuccessMessageStack.splice(idIndex, 1);
                        setExportPdfSuccessMessageStack(exportPdfSuccessMessageStack);
                    }
                });
            },
        },
    );

    const viewNotification = useMutation((notification) => api.notifications.viewNotification(notification), {
        onSuccess(_res, notification) {
            queryClient.invalidateQueries('notifications');
        },
        onError: (_res, notification) => {},
    });

    return {
        notifications,
        viewNotification: viewNotification.mutate,
        exportPdfSuccessMessageStack,
        setExportPdfSuccessMessageStack,
    };
}
